import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { FETCH_BASIC_SETUP_ASYNC, TOGGLE_DISMISS_ASYNC } from './constants'

const initialState = {
  data: [],
  loader: false,
  error: null,

  stepLoader: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_FILTER_CHANGE:
      return {
        ...state,
        loader: false,
      }
    case FETCH_BASIC_SETUP_ASYNC.INITIATE:
      return { ...state, loader: true }
    case FETCH_BASIC_SETUP_ASYNC.SUCCESS:
      return {
        ...state,
        error: null,
        data: action.payload.data,
        loader: false,
      }
    case FETCH_BASIC_SETUP_ASYNC.ERROR:
      return { ...state, error: action.error }
    case FETCH_BASIC_SETUP_ASYNC.CANCEL:
      return { ...state, loader: false }
    case TOGGLE_DISMISS_ASYNC.INITIATE:
      return {
        ...state,
        stepLoader: {
          ...state.stepLoader,
          [action.payload.body.step]: true,
        },
      }
    case TOGGLE_DISMISS_ASYNC.SUCCESS:
      return {
        ...state,
        data: state.data.map((elem) =>
          action.payload.body.step === elem.step ? { ...elem, dismissed: !elem.dismissed } : elem
        ),
        stepLoader: {
          ...state.stepLoader,
          [action.payload.body.step]: false,
        },
      }
    case TOGGLE_DISMISS_ASYNC.ERROR:
    case TOGGLE_DISMISS_ASYNC.CANCEL:
      return {
        ...state,
        stepLoader: {
          ...state.stepLoader,
          [action.payload.body.dismissed]: false,
        },
      }
    default:
      return state
  }
}
